export default [{
    type: 'test_campaign_creation',
    amount: -1
  }, {
    type: 'test_rating',
    amount: -1
}]